/**
 * Mapea códigos/errores del RPC de promociones a copy friendly.
 * El código interno se preserva aparte (ingestError / Sentry).
 */
export function extractPromotionRemoteCode(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  // jsonb body: { ok:false, code:'plan_disabled' } ya llega como 'plan_disabled'
  const known = [
    'feature_disabled',
    'plan_disabled',
    'stale',
    'rpc_rejected',
    'organization_mismatch',
    'operationId_required',
    'promotion_id_required',
    'promotion_payload_incomplete',
    'event_id_required',
  ];
  for (const code of known) {
    if (trimmed === code || trimmed.startsWith(`${code}:`) || trimmed.startsWith(`${code} `)) {
      return code;
    }
  }
  if (/module_permission_denied/i.test(trimmed)) return 'module_permission_denied';
  return null;
}

export function mapPromotionRemoteError(raw: string | null | undefined): string {
  const code = extractPromotionRemoteCode(raw);
  switch (code) {
    case 'feature_disabled':
      return 'Las promociones no están habilitadas en este momento.';
    case 'plan_disabled':
      return 'Tu plan no incluye promociones. Activá Crece para usarlas.';
    case 'module_permission_denied':
      return 'No tenés permiso para editar promociones. Pedile a un admin.';
    case 'stale':
      return 'Hay una versión más nueva de esta promo. Refrescá e intentá de nuevo.';
    case 'organization_mismatch':
      return 'La promo no pertenece a esta organización. Refrescá e intentá de nuevo.';
    case 'operationId_required':
    case 'promotion_id_required':
    case 'promotion_payload_incomplete':
    case 'event_id_required':
    case 'rpc_rejected':
      return 'No se pudo guardar la promoción. Reintentá.';
    default: {
      const msg = (raw ?? '').trim();
      // No mostrar códigos snake_case crudos
      if (msg && !/^[a-z][a-z0-9_]+$/i.test(msg)) return msg;
      return 'No se pudo guardar la promoción. Reintentá.';
    }
  }
}
